import React from 'react';
import { Outlet } from 'react-router-dom';

const PricingContent = () => {
  return <Outlet />;
};

export default PricingContent;
